import createIcon from '../../createIcon';

/**
 * @component @name OfflinePin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjUgMiAyIDYuNSAyIDEyQzIgMTcuNSA2LjUgMjIgMTIgMjJDMTcuNSAyMiAyMiAxNy41IDIyIDEyQzIyIDYuNSAxNy41IDIgMTIgMlpNMTcgMThIN1YxNkgxN1YxOFpNMTAuMyAxNEw3IDEwLjdMOC40IDkuM0wxMC4zIDExLjJMMTUuNiA1LjlMMTcgNy4zTDEwLjMgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OfflinePin = createIcon('OfflinePin', [
  [
    'path',
    {
      d: 'M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM17 18H7V16H17V18ZM10.3 14L7 10.7L8.4 9.3L10.3 11.2L15.6 5.9L17 7.3L10.3 14Z',
      key: '1tax6p',
    },
  ],
]);

export default OfflinePin;
